import React from 'react';
import { render } from 'react-dom';
import Highcharts from 'highcharts';
import RoutesFile from './routes';
import './styles/Global.css';

require('highcharts/modules/exporting')(Highcharts);

render(<RoutesFile />, document.getElementById('root'));
